<template>
    <v-container fluid fill-height>
        <v-col class="ma-0 pa-0">
            <v-card width="100%" class="mb-4 pb-1">
                <!-- Filtri -->
                <v-row class="ma-0 pa-0 ">
                    <div>
                        <v-btn text v-on:click="caricaDati()" fab class="mt-3" small style="margin-right: 0px;">
                            <v-icon color="primary">refresh</v-icon>
                        </v-btn>
                    </div>
                    <div class="ml-0" style="width: 6em">
                        <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                            transition="scale-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :disabled="loadingTable" class="ml-0 mt-5" color="primary" v-model="date"
                                    label="Mese" prepend-icon="event" readonly dense v-on="on" v-bind="attrs"
                                    hide-details />
                            </template>
                            <v-date-picker color="primary" type="month" v-model="date" :first-day-of-week="1"
                                :disabled="loadingTable" @input="menu = false; caricaDati()" locale="it-it" />
                        </v-menu>
                    </div>
                    <v-spacer class="desktop" />

                    <v-text-field class="ml-2 mt-5" color="primary" v-model="search" append-icon="search" label="Cerca"
                        hide-details dense />
                </v-row>

            </v-card>
            <v-row no-gutters class="mb-10">
                <v-col>
                    <v-data-table :loading="loadingTable" loading-text="Caricamento dati in corso..."
                        no-data-text="Nessun dato disponibile" :headers="headerTabella" @page-count="pageCount = $event"
                        mobile-breakpoint="0" :items="errorList" :page.sync="page" :items-per-page="itemsPerPage"
                        class="elevation-1" :search="search" fixed-header dense hide-default-header>
                        <template v-slot:header="{ props: { headers } }">
                            <thead>
                                <tr>
                                    <th v-for="(head, i) in headers" :key="i">
                                        <span>{{ head.text }}</span>
                                    </th>
                                </tr>
                            </thead>
                        </template>

                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.utente }}</td>
                                <td>{{ parseData(item.dateOccur) }}</td>
                                <td>{{ item.menu }}</td>
                                <td>{{ item.role }}</td>
                                <td>{{ item.action }}</td>
                                <td><span class="ml-2 center-vertical-items">
                                        <v-icon v-if="item.debug" v-tooltip.bottom="'Debug'">bug_report</v-icon>
                                        <v-icon v-else v-tooltip.bottom="'In production'">manage_accounts</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

        </v-col>
    </v-container>
</template>
<script>
import { get_errors } from "@/api/api.tools.js";

export default {
    name: "ErrorPage",

    data: () => ({
        date: new Date().toISOString().substr(0, 7),
        menu: false,

        page: 1,
        pageCount: 0,
        itemsPerPage: 50,
        search: "",

        loadingTable: false,
        headerProps: {
            sortByText: "Ordina per",
        },

        headerTabella: [
            { text: "UserID", value: "userID" },
            { text: "Date", value: "dateOccur" },
            { text: "Menu", value: "menu" },
            { text: "Role", value: "role" },
            { text: "Operazione", value: "action" },
            { text: "Stato", value: "debug" },
        ],

        errorList: [],
    }),

    methods: {

        async caricaDati() {
            this.loadingTable = true;
            let par = {
                DateStart: this.date + "-01",
                DateEnd: this.date + "-01",
            };

            let res = await get_errors(par, "logs");
            this.errorList = res.data;

            this.loadingTable = false;
        },

        parseData(data) {
            if (data.length == 0) return "";

            const [month, day, year] = data.split("/");
            return `${day}/${month}/${year}`;
        },
    },

    mounted() {
        this.caricaDati();
    },
};
</script>